/* eslint-disable react-hooks/exhaustive-deps */
import classname from "classnames";
import { forEach } from "lodash";
import { cloneDeep, isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteWorkHistory, getWorkHistoryCommuteList, getWorkHistoryCommuteListDownloads } from "../../../apis/work-history";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import Profile from "../../../components/Profile";
import { ControlTable } from "../../../components/Table";
import { WORK_SCHEDULE_TYPES } from "../../../constants/WORK";
import useForm from "../../../hooks/useForm";
import { dateToFormat, dateToViewFormat, formatHourSecond, getDay } from "../../../utils/date";
import { downExcelFile } from "../../../utils/download";
// import { getPartList } from "../../../utils/getPartList";
import { getParams, getExcelDownParams } from "../../../utils/params";
import { permissionCheck } from "../../../utils/permission";
import systemAlert from "../../../utils/systemAlert";
import { translation } from "../../../utils/translator";
import {
  getString24HourFormat
} from "../../../utils/work-schedule-calculator";
import CommuteTimeManager from "./CommuteTimeManger";
import WorkHistoryManager from "./WorkHistoryManger";

const Attendance = () => {
  const history = useHistory();
  const { parts, employees, permissions } = useSelector(
    (store) => ({
      parts: store.Data.parts,
      employees: store.Data.employees,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );
  const [fields, setFields] = useState([]);
  // 출퇴근기록 수정
  const [commuteOpen, setCommuteOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'COMMUTE_MANAGEMENT');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMMUTE_MANAGEMENT");
      }
    }
  }, [permissions]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    selectedList, setSelectedList,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: { searchEmployees: [] },
      order: [
        {
          // commuteStartTime: "desc"
          workDate: "desc"
        },
      ],
      range: {
        commuteStartTime: [
          // workDate: [
          getDay(7), getDay()
          // "2021-08-01", "2021-08-31"
        ]
      },
      page: 0,
      limit: 10
    },
  );


  useEffect(() => {
    setFields([
      // workStartTime, workEndTime 근무시작, 근무종료
      {
        width: '95px',
        title: "근무일",
        key: "workDate",
        onValue: (value, field, data) => {
          const targetDay = value || data.commuteStartTime;
          // const targetDay = value || data.workDate
          return targetDay ? dateToViewFormat(targetDay) : '-';
        },
      },
      {
        title: "구분",
        key: "schedule.commuteType",
        onValue: (value, field, data) => {
          let v = "-";
          if (data.schedule && data.schedule.commuteType) {
            v = data.schedule.commuteType;
          }
          return translation(WORK_SCHEDULE_TYPES, v);
        },
      },
      {
        title: "근무명",
        key: "workScheduleTitle",
        onValue: (value, field, data) => {
          return value || "-";
        },
      },
      {
        title: "근무일정",
        key: "workSchedule",
        type: 'html',
        onValue: (value, field, data) => {
          let schedule = "-";
          if (data.dayType === 'workday') {
            if (!isEmpty(data.workStartTime)) {
              schedule = `${getString24HourFormat(data.workStartTime)}`;
            }
            if (!isEmpty(data.workEndTime)) {
              schedule += ` - ${getString24HourFormat(data.workEndTime)}`;
            }

            if (!isEmpty(data.vacations)) {
              forEach(data.vacations, (v) => {
                let quarterCount = 0;
                let halfCount = 0;
                let allCount = 0;

                if (v.vacationDayType === 'quarter') {
                  quarterCount++;
                  schedule += `, 반반차 ${quarterCount}`;
                }

                if (v.vacationDayType === 'half') {
                  halfCount++;
                  schedule += `, 반차 ${halfCount}`;
                }

                if (v.vacationDayType === 'all') {
                  allCount++;
                  schedule += `, 연차 ${allCount}`;
                }
              });
            }
          }

          if (data.dayType === 'holiday') {
            schedule = isEmpty(data.vacations) ? '휴일' : '연차';
          }

          return schedule;
        },
      },
      {
        title: "부서",
        key: "partIdx",
        onTranslator: {
          list: [
            ...parts.map((part) => ({
              label: part.partName,
              value: part.idx,
            })),
          ],
        },
      },
      {
        title: "이름",
        key: "employeeIdx",
        onValue: (value) => {
          return (
            <Profile employeeIdx={value} />
          );
        }
      },
      {
        title: "출근",
        key: "commuteStartTime",
        onValue: (value, field, data) => {
          const d = new Date(value);
          return (
            <div className={classname("commute-wrap", { empty: isEmpty(value) })}>
              {!isEmpty(value) && <p className="commute-date">{dateToViewFormat(d)}</p>}
              <span className={classname("commute-time", { "color-red-100": data.isLate })}>
                {!isEmpty(value) ? dateToFormat(value, formatHourSecond) : "-"}
              </span>
            </div>
          );
        },
      },
      {
        title: "퇴근",
        key: "commuteEndTime",
        onValue: (value, field, data) => {
          const d = new Date(value);
          return (
            <div className={classname("commute-wrap", { empty: isEmpty(value) })}>
              {!isEmpty(value) && <p className="commute-date">{dateToViewFormat(d)}</p>}
              <span
                className={classname("commute-time", { "color-red-100": data.isEarlyLeft })}
              >
                {!isEmpty(value) ? dateToFormat(value, formatHourSecond) : "-"}
              </span>
            </div>
          );
        },
      },
      {
        title: "휴게",
        key: "restTimes",
        onValue: (value, field, data) => {
          let v = "-";
          if (data.restTimeInSeconds > 0) v = value;
          return v;
        },
      },
      {
        title: "결근",
        key: "isAbsence",
        onValue: (value, field, data) => {
          return (
            <span
              className={classname("", { "color-red-100": data.isAbsence })}
            >
              {value ? '결근' : "-"}
            </span>
          );
        },
      },
      {
        title: "지각",
        key: "lateTimes",
        onValue: (value, field, data) => {
          const v = data.isLate ? value : "-";
          return (
            <span className={classname("", { "color-red-100": data.isLate })}>
              {v}
            </span>
          );
        },
      },
      {
        title: "조퇴",
        key: "earlyLeftTimes",
        onValue: (value, field, data) => {
          const v = data.isEarlyLeft ? value : "-";
          return (
            <span
              className={classname("", { "color-red-100": data.isEarlyLeft })}
            >
              {v}
            </span>
          );
        },
      },
      {
        title: "근로시간미달",
        key: "shortWorkTimes",
        onValue: (value, field, data) => {
          let v = "-";
          if (data.shortWorkTimeInSeconds > 0) {
            v = value;
          }
          return (
            <span
              className={classname("", {
                "color-red-100": v !== "-",
              })}
            >
              {v}
            </span>
          );
        },
      },
    ]);
  }, [parts, employees]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (params) => {

    const _params = cloneDeep(params);
    if (!isEmpty(_params.search.employeeIdxs)) {
      _params.search.employeeIdxs = _params.search.employeeIdxs.map(e => e.idx);
    }
    if (!isEmpty(_params.range.commuteStartTime)) {
      _params.range.commuteStartTime = {
        from: _params.range.commuteStartTime[0],
        to: _params.range.commuteStartTime[1],
      };
    }

    getWorkHistoryCommuteList({
      ...getParams(_params)
    })
      .then((res) => {
        setList(res.data.commutes);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      }, []);
  };

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const _params = cloneDeep(form);
        if (!isEmpty(_params.search.employeeIdxs)) {
          _params.search.employeeIdxs = _params.search.employeeIdxs.map(e => e.idx);
        }
        if (!isEmpty(_params.range.commuteStartTime)) {
          _params.range.commuteStartTime = {
            from: _params.range.commuteStartTime[0],
            to: _params.range.commuteStartTime[1],
          };
        }
        getWorkHistoryCommuteListDownloads(getExcelDownParams(_params)).then((res) => {
          downExcelFile(res, '출퇴근 기록.xlsx');
        });
      },
    },
  ];

  const filters = [
    {
      title: "조회기간",
      type: "customdatepicker",
      key: "range.commuteStartTime",
    },
    {
      title: "사람 선택",
      type: "searchEmployees",
      key: "search.employeeIdxs",
    },
  ];

  const tableButtons = [
    {
      label: "출퇴근 수정",
      action: () => {
        setCommuteOpen(true);
      },
      color: 'gray-line',
      disabled: isEmpty(selectedList),
    },
    {
      label: "근무기록 수정",
      action: () => {
        setHistoryOpen(true);
      },
      color: 'gray-line',
      disabled: isEmpty(selectedList),
    },
    {
      label: '근무기록 삭제',
      action: () => {
        const historyIdxs = [selectedList[0].idx];
        // const historyIdxs = []
        // forEach(selectedList, data => {
        //   historyIdxs.push(data.idx)
        // })
        systemAlert('해당 근무기록을 삭제하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '삭제',
              onClick: () => {
                setIsLoading(true);
                deleteWorkHistory(historyIdxs)
                  .then(() => {
                    submit(form);
                    setSelectedList([]);
                  })
                  .catch(() => { })
                  .finally(() => setIsLoading(false));
              }
            }
          ]
        });
      },
      color: 'gray-line',
      disabled: isEmpty(selectedList),
    },
  ];

  const getDisabled = (data) => {
    let disabled = false;

    if (!isEmpty(selectedList)) {
      if (!selectedList.includes(data)) {
        disabled = true;
      }
    }

    return disabled;
  };

  return (
    !isEmpty(targetPermission) && (
      <div className="commute-list-container">
        <PageHeader title="출퇴근 관리" buttons={headerButtons} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isControl={targetPermission.level > 1}
          isHideAllCheck
          isLoading={isLoading}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          selectedList={selectedList}
          setSelected={setSelectedList}
          buttons={targetPermission.level > 1 ? tableButtons : []}
          checkboxDisabled={getDisabled}
        />
        {commuteOpen && (
          <CommuteTimeManager
            open={commuteOpen}
            setOpen={setCommuteOpen}
            historyData={selectedList}
            setHistoryData={setSelectedList}
            submit={() => submit(form)}
          />
        )}
        {historyOpen && (
          <WorkHistoryManager
            open={historyOpen}
            setOpen={setHistoryOpen}
            historyData={selectedList}
            setHistoryData={setSelectedList}
            submit={() => submit(form)}
          />
        )}
      </div>
    ));
};

export default Attendance;
